// types
import { createSlice } from '@reduxjs/toolkit';

const initialState = require('../initialState').menuInitialState;

const menu = createSlice({
    name: 'menu',
    initialState,
    reducers: {
        activeItem: (state, action) => {
            state.filter.enabled = action.payload.filterMenu;
            state.filter.opened = false;
            state.openItem = action.payload.openItem;
        },

        activeComponent: (state, action) => {
            state.openComponent = action.payload.openComponent;
        },

        openDrawer: (state, action) => {
            state.drawerOpen = action.payload.drawerOpen;
        },

        openComponentDrawer: (state, action) => {
            state.componentDrawerOpen = action.payload.componentDrawerOpen;
        },

        openFilterDrawer: (state) => {
            state.filter.opened = !state.filter.opened;
        }
    }
});

export default menu.reducer;

export const { activeItem, activeComponent, openDrawer, openComponentDrawer, openFilterDrawer } = menu.actions;
